// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"media-library"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 10L22 21L2 21L2 10L22 10Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 6.5L4 6.5M18 3L6 3M22 10V21L2 21L2 10L22 10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M13 15.5L10.75 16.799L10.75 14.201L13 15.5Z","strokeWidth":"props.strokeWidth"}}]}]};

const MediaLibraryIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'media-library',
    ref,
    icon: element,
  },
));

MediaLibraryIcon.displayName = 'MediaLibraryIcon';

export default MediaLibraryIcon;
